import { Menu, Avatar, Button } from '@mantine/core';
import { IconLogout, IconSettings, IconUser } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { api } from '../api/client.ts';
import { useAuthStore } from '../auth/store.ts';

export function UserMenu() {
  const user = useAuthStore(s => s.user);
  const setUser = useAuthStore(s => s.setUser);
  const open = useAuthStore(s => s.openLoginModal);
  const navigate = useNavigate();
  const qc = useQueryClient();

  if (!user) {
    return <Button size="xs" onClick={open}>Sign in</Button>;
  }

  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <Avatar radius="xl" size={32} style={{ cursor: 'pointer' }}>
          {(user.firstName?.[0] ?? user.login[0] ?? '?').toUpperCase()}
        </Avatar>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{user.login}</Menu.Label>
        <Menu.Item leftSection={<IconUser size={16} />} onClick={() => navigate('/settings')}>
          Settings
        </Menu.Item>
        <Menu.Item leftSection={<IconSettings size={16} />} onClick={() => navigate('/password')}>
          Change password
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconLogout size={16} />}
          color="red"
          onClick={async () => {
            // Only clear client state if the server actually destroyed the
            // session — otherwise (network/CSRF failure) the session stays live
            // and forgetting it client-side is a hazard on shared machines.
            let res;
            try {
              res = await api.post('/api/logout');
            } catch {
              res = undefined;
            }
            if (!res || res.status < 200 || res.status >= 300) {
              notifications.show({ message: 'Sign-out failed — you are still signed in. Please try again.', color: 'red' });
              return;
            }
            setUser(null);
            qc.clear();
            navigate('/');
          }}
        >
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
